(function ($, Drupal, once) {
    Drupal.behaviors.starRating = {
      attach: function (context) {
        // Use once to ensure elements are processed only once
        $(once('star-rating', '.star-rating', context)).each(function () {
          const $container = $(this);
          const rating = parseFloat($container.data('rating')); // Get the rating
          if (isNaN(rating)) {
            console.warn('Invalid rating value:', $container.data('rating'));
            return;
          }
  
          const fullStars = Math.floor(rating); // Full stars
          const decimalPart = rating - fullStars; // Decimal for partial star
          const maxStars = 5; // Maximum stars
  
          // Clear existing stars
          $container.empty();
  
          // Add full stars
          for (let i = 0; i < fullStars; i++) {
            $container.append('<span class="star full"></span>');
          }
  
          // Add partial star if needed
          if (decimalPart > 0) {
            const percentage = decimalPart * 100;
            const partialStar = $('<span class="star partial"></span>');
            partialStar.css(
              'background',
              `linear-gradient(to right, #f7c02d ${percentage}%, #ddd ${percentage}%)`
            );
            $container.append(partialStar);
          }
  
          // Add empty stars
          const emptyStars = maxStars - fullStars - (decimalPart > 0 ? 1 : 0);
          for (let i = 0; i < emptyStars; i++) {
            $container.append('<span class="star empty"></span>');
          }
        });
      },
    };
  })(jQuery, Drupal, once);
  